import { media, type Style } from '@glitz/core';
import { styled } from '@glitz/react';
import {
  minLargeViewportMediaQuery,
  minMediumViewportMediaQuery,
  maxSmallViewportMediaQuery,
  maxMobileViewportMediaQuery,
  minHugeViewportMediaQuery,
  minXLargeViewportMediaQuery,
} from './media';

export function createMaxMobileViewportDecorator(style: Style) {
  return styled(media(maxMobileViewportMediaQuery, style));
}

export function createMaxSmallViewportDecorator(style: Style) {
  return styled(media(maxSmallViewportMediaQuery, style));
}

export function createMinMediumViewportDecorator(style: Style) {
  return styled(media(minMediumViewportMediaQuery, style));
}

export function createMinLargeViewportDecorator(style: Style) {
  return styled(media(minLargeViewportMediaQuery, style));
}

export function createMinHugeViewportDecorator(style: Style) {
  return styled(media(minHugeViewportMediaQuery, style));
}

export function createMinXLargeViewportDecorator(style: Style) {
  return styled(media(minXLargeViewportMediaQuery, style));
}
